<script setup lang="ts">
const props = defineProps<{
  ids: number[]
}>()

const { data: sources } = await useAnnotationSources(props.ids)
</script>

<template>
  <USlideover
    title="Bronnen"
    close-icon="bx:x"
  >
    <template #default>
      <slot />
    </template>
    <template #body>
      <div class="grid gap-4">
        <ApplicationContentAnnotationSlideoverSource
          v-for="source in sources"
          :key="source.path"
          :source="source"
        />
      </div>
    </template>
  </USlideover>
</template>
